import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-add\">\n    <path fill-rule=\"evenodd\" d=\"M17.558 12.991H12.01v5.522c0 .276-.223.5-.5.5-.276 0-.5-.224-.5-.5v-5.522H5.488c-.276 0-.5-.223-.5-.5 0-.276.224-.5.5-.5h5.522V6.443c0-.277.224-.5.5-.5.277 0 .5.223.5.5v5.548h5.548c.277 0 .5.224.5.5 0 .277-.223.5-.5.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol